import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "28",
  fill: "currentColor",
  viewBox: "0 0 30 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 13.606c0-.331.128-.648.354-.878l5.223-5.28c2.307-2.336 4.616-4.67 6.939-7.021a1.139 1.139 0 0 1 .873-.341c.323.02.625.18.83.442l.177.224.365.467a1.265 1.265 0 0 1-.09 1.65l-9.042 9.158h22.21c.64 0 1.161.547 1.161 1.22v.786c0 .672-.52 1.218-1.161 1.218H6.189l2.45 2.479c2.197 2.223 4.377 4.427 6.55 6.627.225.228.353.538.357.868.002.327-.12.64-.34.871-.18.19-.343.36-.527.55l-.082.084a1.124 1.124 0 0 1-1.624.012C8.951 22.675 4.92 18.596.854 14.482a1.25 1.25 0 0 1-.354-.878v.002Z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M29.5 27.084H.5v-27h29z" })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }